import { useContext, useState } from "react";
import {
	CustomEmojiData,
	OptionPreset,
} from "../../../../../../common/sesh_types";
import { DashboardUtils, RevertDescriptor } from "../../../dashboard_utils";
import { GuildListContext } from "../../../sesh_router";
import RSVPOptionsForm from "../../rsvp_options";
import { ModifySettingsButton } from "../base_components/modify_settings_button";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { useCurrentGuildData } from "../hooks/use_guild_data";
import { useUserContext } from "../hooks/use_user_context";
import { RSVPOptionsTable } from "../rsvp_options_table";
import { SeshAccordianComponent } from "../sesh_accordian_component/sesh_accordian_component";

export function SignupOptionsBlurb(props: {
	current_signup_preset: OptionPreset;
	setPreset: (preset: OptionPreset) => void;
	user_presets: OptionPreset[];
	custom_emojis: CustomEmojiData[];
	is_disabled: boolean;
	is_edit: boolean;

	revert_descriptor?: RevertDescriptor<OptionPreset>;
}) {
	const [is_modal_open, setIsModalOpen] = useState(false);

	return (
		<>
			<div className="field blurb active">
				{DashboardUtils.CreateHeaderAndInfoButton(
					"RSVP Options",
					"RSVP options, reminders, and waitlist options for this event.",
					undefined,
					undefined,
					false,
					undefined,
					props.is_disabled,
					false,
					props.revert_descriptor
				)}
				<div className="flex flex-col gap-2">
					<RSVPOptionsTable options={props.current_signup_preset} />
					<div className="">
						<ModifySettingsButton
							disabled={props.is_disabled}
							onClick={() => setIsModalOpen(true)}
						>
							Modify
						</ModifySettingsButton>
					</div>
				</div>
			</div>

			{is_modal_open && (
				<SignupOptionsModal
					onClose={() => setIsModalOpen(false)}
					current_signup_preset={props.current_signup_preset}
					is_edit={props.is_edit}
					user_presets={props.user_presets}
					custom_emojis={props.custom_emojis}
					setPreset={props.setPreset}
				/>
			)}
		</>
	);
}

function SignupOptionsModal(props: {
	current_signup_preset: OptionPreset;
	user_presets: OptionPreset[];
	custom_emojis: CustomEmojiData[];
	is_edit: boolean;
	onClose: () => void;
	setPreset: (preset: OptionPreset) => void;
}) {
	const [preset, setPreset] = useState(props.current_signup_preset);

	const guild_list = useContext(GuildListContext);
	const guild = useCurrentGuildData();
	const user_context = useUserContext();

	return (
		<DashboardUtils.SeshModal
			is_active={true}
			onClose={props.onClose}
			title={"RSVP Options"}
			content={
				<div className="flex h-full min-h-0 flex-col gap-2">
					<div className="h-full w-full">
						<RSVPOptionsForm
							current_preset={preset}
							updateFunc={(val) => {
								setPreset(val);
							}}
							is_premium={guild.is_premium}
							is_edit={props.is_edit}
							user_presets={props.user_presets}
							user_id={user_context.id}
							custom_emojis={props.custom_emojis}
							all_guild_data={guild_list}
							token_type={user_context.token_type}
							access_token={user_context.access_token}
							from_event_creation
							ignore_unmount
						/>
					</div>
					<SeshPrimaryButton
						className="ml-auto w-fit"
						onClick={() => {
							props.setPreset(preset);
							props.onClose();
						}}
					>
						Set
					</SeshPrimaryButton>
				</div>
			}
		></DashboardUtils.SeshModal>
	);
}

{
	/* <div className="flex gap-4">
				{props.current_signup_preset.custom_options.map(
					(option, index) => (
						<div className="flex flex-col">
							<div className="">{option.name}</div>
							<InlineEmoji key={option.emoji} option={option} />
						</div>
					)
				)}
			</div> */
}
